var styleDataHash = "9c8e87dc";
const injectCss = () => {
  var css = `.aOmzX,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.cZhNt{align-items:center;color:var(--ricos-settings-text-color,#000);display:flex;font-family:var(--ricos-settings-text-font-family,Helvetica Neue,Helvetica,Arial);font-size:14px;justify-content:center}[dir] .cZhNt{background:transparent;border:0;cursor:pointer;padding:4px}[dir] .cZhNt:hover:not([disabled]){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}.cZhNt.BGPf8{color:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff));fill:var(--ricos-settings-text-color,var(--ricos-action-color-fallback,#116dff))}[dir] .cZhNt.BGPf8{background-color:rgba(var(--ricos-action-color-fallback-tuple,2,97,255),.1)}.cZhNt.BGPf8 svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor)}.cZhNt.tjZex{opacity:.4}[dir] .cZhNt.tjZex{cursor:default}[dir] .cZhNt.xpoUY:not(.BGPf8):hover{background-color:unset}.cZhNt:focus{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.rYOzw{align-items:center;display:flex;gap:8px;height:20px;justify-content:center;min-width:20px;position:relative;width:max-content}.rYOzw.LohJG{height:32px;width:32px}.FUcJY{align-items:center;display:flex;gap:8px;height:20px;justify-content:center;min-width:20px;position:relative;width:max-content}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var ToolbarButton_default = {
  "fontElementMap": "aOmzX",
  "toolbarButtonWrapper": "cZhNt",
  "active": "BGPf8",
  "disabled": "tjZex",
  "mobileToolbarButtonWrapper": "xpoUY",
  "toolbarButton": "rYOzw",
  "mobileToolbarButton": "LohJG",
  "iconTextWrapper": "FUcJY"
};
export {
  ToolbarButton_default as default,
  injectCss
};
//# sourceMappingURL=ToolbarButton-scss.js.map
